module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('button', {
    attrs: {
      "type": "button",
      "data-toggle": "block-option",
      "data-action": "refresh_toggle",
      "data-action-mode": "demo"
    },
    on: {
      "click": function($event) {
        return _vm.readJournalReadings()
      }
    }
  }, [_c('i', {
    staticClass: "si si-refresh"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelLogBook[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "400px"
    }
  }, [(_vm.totalWorkingTime > 0) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-wrench fa-1x text-warning"
  }), _vm._v(" " + _vm._s(_vm.textLableTotalMaintenance[_vm.actualLanguage]) + " " + _vm._s(_vm.totalWorkingTime) + " Hr")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('ul', {
    staticClass: "list list-activity push"
  }, _vm._l((_vm.journalItems), function(logItem, index) {
    return _c('li', [(logItem.event_type === 'Alert') ? _c('i', {
      staticClass: "fa fa-bell text-danger"
    }) : _vm._e(), _vm._v(" "), (logItem.event_type === 'comment') ? _c('i', {
      staticClass: "fa fa-comment text-info"
    }) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('i', {
      staticClass: "fa fa-wrench text-warning"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(logItem.timestamp_local.substr(0, 16)))]), _vm._v(" "), _c('div', [_c('a', [_vm._v(_vm._s(logItem.event_info.postedBy))])]), _vm._v(" "), (logItem.event_type === 'comment') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.comment))])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('div', {
      staticClass: "font-w600"
    }, [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Travail: " + _vm._s(logItem.event_info.workTime) + " Hr")])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'maintenance') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.description))])]) : _vm._e(), _vm._v(" "), (logItem.event_type === 'Alert') ? _c('div', [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(logItem.event_info.description))])]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelCommentLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddComment[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addChannelMaintenanceLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddMaintenance[_vm.actualLanguage]))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    attrs: {
      "type": "button",
      "data-toggle": "block-option",
      "data-action": "fullscreen_toggle"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a22171bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ChannelJournal.vue
// module id = 1570
// module chunks = 4